import Api from '../api';
import { apiServices } from 'redux/utils/api_services';
import QueryString from 'query-string';
import { omitBy as _omitBy, isEmpty as _isEmpty } from 'lodash-es';
import { t } from 'i18next';

export default class MetricDefinitionApi extends Api {
  getMetricDefinition = async payload => {
    try {
      const { path, ...queryParams } = payload;
      const queryObj = _omitBy(queryParams, _isEmpty);
      const queryString = QueryString.stringify(queryObj);
      const url = `${apiServices['sphere']}/data/metricDefinition?${queryString}&path=${path}`;
      const { data } = await this.get(url);
      return data;
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  getChromeMetricDefinition = async (props) => {
    const { pathname, search, traceId } = props;
    try {
      const url = `${apiServices['sphere']}/data/metrics?source=chrome&trace_id=${traceId}&path=${pathname}${search}`;
      const { data } = await this.get(url);
      return data;
    }
    catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  }

  getMetricDimensionMapping = async (props) => {
    const { loadNewWarehouse, channel, trace_id, path } = props;
    try {
      const apiData = await this.get(
        `/chartbuilder/metricDimensions?loadNewWarehouse=${loadNewWarehouse}&trace_id=${trace_id}&path=${path}${channel ? `&channel=${channel}` : ''}`
      );
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };
}
